<template>
  <div class="logo-container list-header-operate">
    <div class="logo logo-white"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      list: [],
      bucketInfo: {},
    };
  },
  watch: {
  },
  mounted() {
  },
  methods: {
  },
};
</script>
